module.exports = __webpack_public_path__ + "static/media/sony-wh-h900n.e02ab600.jpg";